import { FaStar } from "react-icons/fa";

const TestimonialCard = ({ item }) => {
  const rating = Number(item?.rating) || 0;

  return (
    <div
      className="
        h-full
        min-h-[360px]
        flex
        flex-col
        bg-white
        rounded-[28px]
        px-8
        py-8
      "
    >
      {/* Rating */}
      <div className="flex items-center gap-1 mb-5 flex-shrink-0">
        {[...Array(rating)].map((_, index) => (
          <FaStar
            key={index}
            className="text-[#FBB800] text-base md:text-lg"
          />
        ))}
      </div>

      {/* Description */}
      <p className="text-[#555555] text-sm md:text-[15px] leading-7">
        “{item?.description}”
      </p>

      {/* Name / Company */}
      <div className="mt-auto pt-5 flex-shrink-0">
        <h4 className="font-bold text-[#222222] text-sm md:text-[15px]">
          {item?.name}
        </h4>

        {item?.position && (
          <p className="text-xs md:text-sm text-[#777777] mt-1">
            {item.position}
          </p>
        )}

        {item?.company && (
          <p className="text-xs md:text-sm text-[#777777] mt-1">
            {item.company}
          </p>
        )}
      </div>
    </div>
  );
};

export default TestimonialCard;